import React from 'react'

const ImageIcon = ( {img} ) => {
  return (
    <img src={img} class="" width={50} />
    
  )
}

export default ImageIcon;